import { useState } from "react";
import { CTabContent } from "@coreui/react";
import "@coreui/coreui/dist/css/coreui.min.css";
import { TextMS } from "../../common/text";
import TicketRefundInfoContent from "./TicketRefundInfoContents";
import { RefundText } from "./TicketCancel.styles";

const TicketRefundInfo = ({ ticket }) => {
  const [activeKey] = useState(1);

  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <RefundText>[취소약관]</RefundText>
      </div>
      <CTabContent
        style={{
          height: "100%",
          overflow: "scroll",
          border: "1px solid rgba(0,0,0,0.3)",
          borderRadius: "5px",
        }}
      >
        <TicketRefundInfoContent
          activeKey={activeKey}
          ticket={ticket}
        ></TicketRefundInfoContent>
      </CTabContent>
    </>
  );
};

export default TicketRefundInfo;
